<template>
  <div>
    <field-label :field="field"></field-label>
    <v-textarea
      :value="value"
      :rules="rules"
      :disabled="field.disabled"
      @input="input"
      outlined
      dense
    ></v-textarea>
  </div>
</template>

<script>
import FieldLabel from '@/components/editor/partials/FieldLabel'

export default {
  name: 'TextAreaField',
  props: ['value', 'field'],
  components: {
    FieldLabel
  },
  computed: {
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    }
  },
  methods: {
    input(value) {
      this.$emit('update:value', value)
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if (this.value === undefined && this.field.default !== undefined) {
      //   this.input(this.field.default)
      // }
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>
